import React from "react";

export default function Github() {
  return (
    <a href="https://github.com/richardmarquez2001/NOISE-Frontend" target="_blank">
      <svg
        className="icon"
        width="54"
        height="53"
        viewBox="0 0 54 53"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.5129 0C11.8716 0 0 12.1734 0 27.1743C0 39.1821 7.5988 49.3562 18.133 52.9527C18.2807 52.9847 18.4315 53.0006 18.5827 53C19.5651 53 19.9439 52.2783 19.9439 51.6513C19.9439 51.0006 19.9202 49.2971 19.9084 47.0257C19.0314 47.2311 18.1342 47.3383 17.2334 47.3451C12.132 47.3451 10.9721 43.3819 10.9721 43.3819C9.76481 40.2469 8.0249 39.4069 8.0249 39.4069C5.71685 37.7861 8.01306 37.7388 8.19061 37.7388H8.20244C10.8656 37.9754 12.2622 40.5544 12.2622 40.5544C13.5879 42.8732 15.3633 43.5239 16.9493 43.5239C17.9981 43.5029 19.0306 43.261 19.9794 42.814C20.2161 41.0632 20.9026 39.8683 21.6601 39.1821C15.7776 38.496 9.58727 36.1654 9.58727 25.7547C9.58727 22.7853 10.617 20.36 12.3096 18.4672C12.0374 17.781 11.126 15.0127 12.57 11.2743C12.7637 11.228 12.9627 11.2081 13.1618 11.2152C14.1205 11.2152 16.2865 11.5819 19.861 14.0663C24.2044 12.8517 28.7979 12.8517 33.1412 14.0663C36.7157 11.5819 38.8817 11.2152 39.8404 11.2152C40.0395 11.2081 40.2385 11.228 40.4322 11.2743C41.8763 15.0127 40.9649 17.781 40.6926 18.4672C42.3852 20.3719 43.4149 22.7971 43.4149 25.7547C43.4149 36.189 37.2128 38.4841 31.3066 39.1585C32.2535 39.9984 33.1057 41.6547 33.1057 44.1864C33.1057 47.8183 33.0702 50.7522 33.0702 51.6395C33.0702 52.2783 33.4371 53 34.4195 53C34.5785 53.0007 34.7372 52.9848 34.8929 52.9527C45.4389 49.3562 53.0259 39.1703 53.0259 27.1743C53.0259 12.1734 41.1542 0 26.5129 0Z"
          fill="black"
        />
      </svg>
    </a>
  );
}
